import { createAsyncThunk } from "@reduxjs/toolkit";
import { LOOKUP_CODES } from "../../../API/UserApi";

import axios from "axios";
import apiHeader from "../../../Components/ApiHeader";

export const deleteLookupCodesAPI: any = createAsyncThunk(
  "deleteLookupTypes",
  async (rowId: any, { rejectWithValue }: any) => {
    const token: any = localStorage.getItem("token");
    const commonHead = apiHeader(token);
    try {
      const res = await axios.delete(LOOKUP_CODES + "/" + rowId, {
        headers: commonHead,
      });
      ;
      return { networkDeleted: res };
    } catch (error) {
      if (error instanceof Error) {
        return rejectWithValue({ error: error.message });
      }
    }
  }
);
